import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[restrictFirstSpace]'
})

export class RestrictFirstSpaceDirective {

  get formControl() {
    return this.ngControl.control;
  }

  ranges = [
    '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
    '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
    '\ud83d[\ude80-\udeff]'  // U+1F680 to U+1F6FF
  ];

  constructor(
    private _el: ElementRef,
    private ngControl: NgModel,
  ) { }

  @HostListener('keydown', ['$event']) onKeyDown(event): any {
    if(event.keyCode === 32) { // space
      let cursorPosition = event.target.selectionEnd;
      let appendSpace = true;

      const startStrings = this._el.nativeElement.value.toString().substring(0, event.target.selectionStart);
      const endStrings = this._el.nativeElement.value.toString().substring(cursorPosition, this._el.nativeElement.value.length);

      if(startStrings.endsWith(' ') || endStrings.startsWith(' ')){
        appendSpace = false;
      }

      const initialValue = startStrings + String.fromCharCode(event.keyCode) + endStrings;
      this._el.nativeElement.value = initialValue.replace(/  +/g, ' ');

      if (initialValue.startsWith(' ')) {
        this._el.nativeElement.value = initialValue.trim();
      }

      this._el.nativeElement.selectionEnd = appendSpace ? cursorPosition + 1 : cursorPosition;

      event.preventDefault();
    }
  }

  @HostListener('blur', ['$event'])
  onBlur() {
    this._el.nativeElement.value = this._el.nativeElement.value.replace(/  +/g, ' ');
    this._el.nativeElement.value = this._el.nativeElement.value.trim();
    this.formControl.patchValue(this._el.nativeElement.value);
  }

  // @HostListener('paste', ['$event'])
  // onPaste(event: any): void {
  //   let data;
  //   let selStart = event.target.selectionStart;
  //   let selEnd = event.target.selectionEnd;
  //   let displayedValue = this._el.nativeElement.value; // existing value
  //   let newRawValue = ''; // New Value
  //   if ((<any>window).clipboardData && (<any>window).clipboardData.getData) // IE
  //     data = (<any>window).clipboardData.getData('Text');
  //   else
  //     data = (event.originalEvent || event).clipboardData.getData('text/plain');
  //   let pastedData = data.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
  //   if (pastedData) {
  //     if (selStart == selEnd)
  //       newRawValue = displayedValue.slice(0, selStart) + pastedData + displayedValue.slice(selStart);
  //     else
  //       newRawValue = displayedValue.slice(0, selStart) + pastedData + displayedValue.slice(selEnd);
  //     this._el.nativeElement.value = newRawValue.trim();
  //     this.formControl.patchValue(this._el.nativeElement.value);
  //   }
  //   event.preventDefault();
  // }

  @HostListener('input', ['$event'])
  onInputChange(event): any {
    let initialValue = this._el.nativeElement.value;
    initialValue = initialValue.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
    if (initialValue) {
      this._el.nativeElement.value = initialValue.replace(/  +/g, ' ');
      /*this._el.nativeElement.value = initialValue.trim();*/

      this.formControl.patchValue(this._el.nativeElement.value);
    }

    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
